<template>
  <v-app>
    <v-main>
      <table-page
        :headers="headers"
        :items="testAcceptedValues"
        :rowCount="25"
      />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TablePage,
  },
  methods: {
    ...mapActions(["getAllTestAcceptedValues"]),
  },
  created() {
    this.$store.commit("setSearchTerm", "");
    this.getAllTestAcceptedValues();
    console.log("this.testAcceptedValues", this.testAcceptedValues);
  },
  computed: {
    ...mapGetters(["currentInstitution", "testAcceptedValues"]),
  },
  data() {
    return {
      headers: [
        { text: "Test", value: "test.title" },
        {
          text: "Accepted Value",
          value: "title",
        },
        { text: "Abbreviation", value: "abbreviation" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "enabledDate" },
        { text: "Created By", value: "enablerAccount" },
      ],
      items: [],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>